import { ICustomTheme } from 'interfaces';
import { styled } from '@material-ui/core/styles';

export const StyledIcon = styled('img')(
  ({ theme }: { theme: ICustomTheme }) => ({
    width: 32,
    marginTop: theme.spacing(4),
    marginLeft: 'auto',
    marginRight: 'auto',
  }),
);
